/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 20.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {VelocityComponent} from 'velocity-react';
import _isEqual from 'lodash/isEqual';
import _size from 'lodash/size';
import _times from 'lodash/times';
import _concat from 'lodash/concat';
import _takeRight from 'lodash/takeRight';
import _take from 'lodash/take';

import BannersSliderControls from '../../components/BannersSlider/banners-slider-controls';
import BannerSliderItem from '../../components/BannersSlider/banners-slider-item';

import {GetBannersShowcase} from '../../actions/showcase/actions-showcase';

class BannerSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      slider: [],
      fake: false,
      interval: null
    };

    this._fake = false;
    this._animationInProgress = false;
  }

  componentWillMount() {

    this.props.GetBannersShowcase();
  }

  componentWillReceiveProps(newProps) {
    let aliquotSlider = [];

    if (this._isNeedFilling(newProps.banners.slider)) {

      let size = _size(newProps.banners.slider);

      aliquotSlider = _times(size * 3, (index) => {
        return newProps.banners.slider[index % size];
      });

      aliquotSlider = _concat(_takeRight(aliquotSlider, 3), aliquotSlider, _take(aliquotSlider, 3));

    } else if (newProps.banners.slider) {

      aliquotSlider = newProps.banners.slider;

      if (newProps.banners.slider.length === 3) {
        this.setState({
          currentPage: 0
        });
      }
    }

    this._initSlider(newProps, aliquotSlider);
  }

  componentWillUnmount() {
    if (this.state.interval) clearInterval(this.state.interval);
  }

  _initSlider(newProps, newSlider) {
    if (this.state.interval) clearInterval(this.state.interval);

    var newState = {
      currentSlide: 0,
      slider: newSlider || []
    };

    if (newProps.banners.slider_delay && _size(newSlider) > 3) newState.interval = setInterval(()=> {
      this.setState({currentPage: (_size(newSlider) / 3 > +this.state.currentPage + 1) ? +this.state.currentPage + 1 : 0});
    }, newProps.banners.slider_delay);

    this.setState(newState);
  }

  _slideRight = () => {
    if (this._animationInProgress) return;

    this.setState({currentPage: (_size(this.state.slider) / 3 > +this.state.currentPage + 1) ? +this.state.currentPage + 1 : 0});
  };

  _slideLeft = () => {
    if (this._animationInProgress) return;

    this.setState({currentPage: (+this.state.currentPage < 1 ) ? _size(this.state.slider) / 3 - 1 : +this.state.currentPage - 1});
  };

  _isNeedFilling(slider = []) {

    return _size(slider) > 3 || _size(slider) % 3 !== 0;
  }


  _onVelocityStart = () => {

    this._animationInProgress = true;
  };

  _onVelocityComplete = () => {

    let newState = {};

    if (this.state.currentPage === 0) {
      newState.currentPage = _size(this.state.slider) / 3 - 2;
      this._fake = true;

      this.setState(newState);

    } else if ((this.state.currentPage + 1) * 3 === _size(this.state.slider)) {
      newState.currentPage = 1;
      this._fake = true;

      this.setState(newState);
    } else {
      this._fake = false;
    }

    this._animationInProgress = false;
  };

  _renderSliderItems() {

    return this.state.slider.map((item, index) => {

      return (<BannerSliderItem key={'banner_' + index} item={item} onAssetSelect={this.props.onAssetSelect} />);
    });
  }

  render() {
    if (!_size(this.props.banners.slider)) {

      return null;
    }

    let ulStyleCSS = {
      width: _size(this.state.slider) * (408 + 6) + 'px'
    };

    let animationCSS = {
      translateX: '-' + (+this.state.currentPage) * (408 + 6) * 3 + 'px',
      translateZ: '0px'
    };

    return (
      <div id="app-banners" style={{display: _size(this.state.slider) ? 'block' : 'none'}}>
        <div className="relative clearfix">
          <div className="adv-slider radius slider">
            {(_size(this.props.banners.slider) > 3) && <BannersSliderControls onSlideLeft={this._slideLeft} onSlideRight={this._slideRight} />}
            <VelocityComponent
              animation={animationCSS}
              duration={this._fake ? 0 : 1000}
              begin={this._onVelocityStart}
              complete={this._onVelocityComplete}
              easing={'easeInOutSine'}>
              <ul id="banner_container" className="banner-container" style={ulStyleCSS}>
                {this._renderSliderItems()}
              </ul>
            </VelocityComponent>
          </div>
        </div>
      </div>
    );
  }
}

BannerSlider.propTypes = {
  showcaseLabel: PropTypes.string,
  banners: PropTypes.object.isRequired,
  GetBannersShowcase: PropTypes.func,
  onAssetSelect: PropTypes.func
};

const mapStateToProps = ({showcase: {banners}}) => ({banners});

const mapDispatchToProps = (dispatch) => bindActionCreators({GetBannersShowcase}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BannerSlider);



// WEBPACK FOOTER //
// ./src/containers/BannersSlider/banners-slider.js